export const initializePaddleBilling = async ({
  targetClassName,
  userData,
  opportunityId,
  venueId,
  type,
  navigate,
}) => {
  try {
    const Paddle = window.Paddle;

    if (!Paddle) {
      console.error("Paddle script not loaded.");
      return;
    }

    // Set the Paddle environment
    if (process.env.REACT_APP_PADDLE_ENVIRONMENT === "sandbox") {
      Paddle.Environment.set("sandbox");
    }

    // define items
    const subscriptionItemsList = [
      {
        priceId: process.env.REACT_APP_PADDLE_SUBSCRIPTION_PRICE_ID,
        quantity: 1,
      },
    ];

    const getProductType = (type) => {

      switch (type) {
        case "smartchannel":
          return "Resbook";
        case "meta":
          return "Meta";
        case "michelin":
          return "The Michelin Guide";
        case "listing":
          return "Listing & Review";
        default:
          return "Mozrest Subscription";
      }
    };

    Paddle.Initialize({
      token: process.env.REACT_APP_PADDLE_TOKEN,
      eventCallback: (event) => {
        if (event.name === "checkout.completed") {
          console.log("Paddle event:", event);
          // Pass state and also encode into URL for robustness
          try { sessionStorage.setItem("checkoutVenueId", venueId || ""); } catch(_) {}
          try { sessionStorage.setItem("checkoutType", type || ""); } catch(_) {}
          const qp = `?vid=${encodeURIComponent(venueId || "")}&type=${encodeURIComponent(type || "")}`;
          navigate(`/thank-you${qp}`, { state: { userData, venueId, type } });
        }
      }
    });

    const sessionEmail = (function(){ try { return sessionStorage.getItem("checkoutEmail") || null; } catch(_) { return null; }})();

    Paddle.Checkout.open({
      items: subscriptionItemsList,
      settings: {
        displayMode: "inline",
        frameInitialHeight: 500,
        frameTarget: targetClassName,
        frameStyle: "width: 100%; min-width: 312px; background-color: transparent; border: none;",
        allowLogout: false,
        showAddTaxId: false,
      },
      customer: {
        email: sessionEmail || userData.email,
        address: {
          country_code: userData.company?.country,
          postal_code: userData.company?.postalCode,
          city: userData.company?.city,
          first_line: userData.company?.address,
        },
        business: {
          name: userData.company?.name,
          tax_identifier: userData.company?.vat,
        },
      },
      metadata: {
        product_type: getProductType(type),
        opportunity_id: opportunityId,
        venue_id: venueId,
      },
    });

  } catch (error) {
    console.error("Error initializing Paddle:", error);
  }
};
